[...document.querySelectorAll('.read-more')].forEach((element) => {
    element.addEventListener('click', () => {
        element.classList.add('read-more--activated');

        // Resize swiper, if needed
        const swiper = element.closest('.swiper-container');
        if (
            swiper &&
            swiper.swiper &&
            typeof swiper.swiper.update == 'function'
        ) {
            swiper.swiper.update();
        }
    });
});
